import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeTree: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="code-tree, file-tree"><path d="M4.75 3V17.75H13.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="16.5" cy="17.75" r="2.75" stroke="currentColor" strokeWidth="1.5"/><circle cx="16.5" cy="9.75" r="2.75" stroke="currentColor" strokeWidth="1.5"/><path d="M5 9.75H13.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCodeTree;
